document.addEventListener('DOMContentLoaded', function () {
    const link = document.querySelector('a[href="#dep-choice-omsk"]')

    if (!link) return
    const linkObserver = new MutationObserver(function (mutationRecords) {
        linkObserver.disconnect()
        link[mutationRecords[0].attributeName] = mutationRecords[0].oldValue
    })

    linkObserver.observe(link, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['href']
    })
})
